import { render, staticRenderFns } from "./SearchByDomain.vue?vue&type=template&id=12d2d19b&"
import script from "./SearchByDomain.vue?vue&type=script&lang=js&"
export * from "./SearchByDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports